import { useState, useRef } from "react";

// Draggable column widths persisted to localStorage (per storageKey) so the
// layout survives reloads. Shared by any table that needs resizable columns
// (product list, quotation items, etc.) - pass a unique storageKey per table.
export function useResizableColumns(storageKey, defaultWidths, minWidths = {}) {
  const [widths, setWidths] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem(storageKey) || "{}");
      return { ...defaultWidths, ...saved };
    } catch {
      return { ...defaultWidths };
    }
  });
  const dragRef = useRef(null);

  const onMouseMove = (e) => {
    if (!dragRef.current) return;
    const { id, startX, startWidth } = dragRef.current;
    const minWidth = minWidths[id] || 60;
    const next = Math.max(minWidth, startWidth + (e.clientX - startX));
    setWidths((w) => ({ ...w, [id]: next }));
  };

  const stopDrag = () => {
    dragRef.current = null;
    window.removeEventListener("mousemove", onMouseMove);
    window.removeEventListener("mouseup", stopDrag);
    setWidths((w) => {
      try { localStorage.setItem(storageKey, JSON.stringify(w)); } catch { /* ignore */ }
      return w;
    });
  };

  const startResize = (id) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    dragRef.current = { id, startX: e.clientX, startWidth: widths[id] };
    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", stopDrag);
  };

  return { widths, startResize };
}
